import React from 'react';
import { Star, Quote } from 'lucide-react';
import { REVIEWS } from '../data/site';
import { TESTIDS } from '../constants/testIds';

const Stars = ({ count = 5 }) => (
  <div className="flex gap-1" aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${i < count ? 'fill-[#E8B842] text-[#E8B842]' : 'text-[#3a3a3a]'}`}
      />
    ))}
  </div>
);

export const Reviews = () => {
  return (
    <section
      id="reviews"
      data-testid={TESTIDS.reviewsSection}
      className="py-20 sm:py-28 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <span className="font-display uppercase tracking-[0.4em] text-xs text-[#E8B842]">
              / What customers say
            </span>
            <h2 className="font-display uppercase font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-4">
              Five star <span className="text-[#E8B842]">reviews</span>.
            </h2>
          </div>

          <div className="bg-[#121212] border border-[#E8B842]/20 px-6 py-5 flex items-center gap-5">
            <div className="flex items-baseline gap-1">
              <span className="font-display font-extrabold text-5xl text-white">5.0</span>
              <span className="text-[#A3A3A3] text-sm">/ 5</span>
            </div>
            <div>
              <Stars count={5} />
              <div className="mt-1 flex items-center gap-2">
                <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden="true">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.75h3.57c2.08-1.92 3.28-4.74 3.28-8.07z" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.75c-.98.66-2.23 1.05-3.71 1.05-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
                </svg>
                <span className="font-display uppercase tracking-wider text-xs text-white">
                  Google Reviews
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              data-testid={`${TESTIDS.reviewCard}-${i}`}
              className={`relative bg-[#0E0E0E] border border-[#E8B842]/15 p-7 hover:border-[#E8B842]/50 transition-colors ${
                i === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <Quote className="absolute top-5 right-5 w-8 h-8 text-[#E8B842]/15" />
              <Stars count={r.stars} />
              <p className="text-[#E5E5E5] text-base leading-relaxed mt-4">
                &ldquo;{r.text}&rdquo;
              </p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-[#1A1A1A]">
                <div className="w-10 h-10 rounded-full bg-[#E8B842] text-black font-display font-bold flex items-center justify-center">
                  {r.name.charAt(0)}
                </div>
                <div className="flex-1">
                  <div className="font-display uppercase tracking-wider text-sm text-white font-bold">
                    {r.name}
                  </div>
                  <div className="text-xs text-[#A3A3A3]">{r.location}</div>
                </div>
                {r.date && (
                  <div className="text-[10px] uppercase tracking-widest text-[#A3A3A3] font-display whitespace-nowrap">
                    {r.date}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
